import React from 'react';

const Sidebar = ({ navigationItems, currentPage, onNavigate, onLogout, minimal }) => {
  return (
    <aside className="dashboard-sidebar">
      <nav className="sidebar-nav">
        <ul className="nav-list">
          {navigationItems && navigationItems.map((item) => (
            <li key={item.id} className="nav-item">
              <button
                className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
                onClick={() => onNavigate(item.id)}
                style={{ justifyContent: 'flex-start', textAlign: 'left' }}
              >
                <span className="nav-text">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-bottom">
        <div className="nav-section">
          <button
            className="nav-link logout-btn"
            onClick={onLogout}
          >
            <span className="nav-text">Logout</span>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;